import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {AttachmentsModalComponent} from './attachments-modal.component';
import {PlanAttachment} from '../../../models/plan-attachment.model';

@Injectable({
    providedIn: 'root'
})
export class AttachmentsModalService extends ModalService {
    showModal(extensions: string[], prefix: string, attachments?: PlanAttachment[], checkPdfSignature?: boolean, maxSize?: number) {
        this.createModalComponent(AttachmentsModalComponent);
        const attachmentsModalComponentInstance = this.modalComponentRef.instance as AttachmentsModalComponent;
        attachmentsModalComponentInstance.title = 'Upload attachment';
        attachmentsModalComponentInstance.extensions = extensions;
        attachmentsModalComponentInstance.prefix = prefix;
        attachmentsModalComponentInstance.attachments = attachments;
        attachmentsModalComponentInstance.maxSizeBytes = maxSize;
        attachmentsModalComponentInstance.checkPdfSignature = checkPdfSignature;
        this.showModalComponent();
        return attachmentsModalComponentInstance.modalClosed;
    }
}
